import { render, staticRenderFns } from "./BasicInfoTab.vue?vue&type=template&id=650aa860&"
import script from "./BasicInfoTab.vue?vue&type=script&lang=js&"
export * from "./BasicInfoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports